import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionCreateDto } from "types/api";

const useAddTerminalSolutionByMerchantMutation = ({
	merchantId,
	onSuccess,
	onError,
}: any) => {
	const dispatch = useDispatch();

	return useMutation(
		(data: TerminalSolutionCreateDto) => {
			return merchantTerminalService.addTerminalSolution({
				merchant_id: merchantId,
				...data,
			});
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Terminal has been created successfully",
					}),
				);
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useAddTerminalSolutionByMerchantMutation;
